import React from "react";


import {
    PulseLoader
} from "react-spinners";


import "./index.scss";


export const ApiRequestLoaderElementComponent = () => {

    return (
        <div className={'page-blackout-element-component'}>
            <div className={'rest-api-request-loader-element-component'}>
                <PulseLoader color={' #F25C3E'} />
            </div>
        </div>
    );

};


export default ApiRequestLoaderElementComponent;
